import React from 'react';
import { Field } from 'redux-form';
import { renderInput, renderSelect } from '../../util';
import { tipoIdentificacion, codigoPais } from '../../catalogos';

const Profile = () => {

  return (
    <>
      <div className="ui segment grid">
        <div className="stackable row">
          <div className="five wide column">
            <div>
              <Field
                label="Tipo Identificación"
                name="Identificacion.Tipo"
                component={renderSelect}
                type="select"
                options={tipoIdentificacion}
              />
            </div>
          </div>
          <div className="five wide column">
            <div>
              <Field
                label="Número cédula"
                name="Identificacion.Numero"
                component={renderInput}
                type="text"
                required
              />
            </div>
          </div>
          <div className="six wide column">
            <div>
              <Field
                label="Email"
                name="CorreoElectronico"
                component={renderInput}
                type="email"
                required
              />
            </div>
          </div>
          <div className="five wide column">
            <div>
              <Field
                label="Nombre completo / Razón social"
                name="Nombre"
                component={renderInput}
                type="text"
                required
              />
            </div>
          </div>
          <div className="five wide column">
            <div>
              <Field
                label="Nombre comercial (opcional)"
                name="NombreComercial"
                component={renderInput}
                type="text"
              />
            </div>
          </div>
          <div className="six wide column">
            <div>
              <Field
                label="Email contador (opcional)"
                name="EmailContador"
                component={renderInput}
                type="email"
              />
            </div>
          </div>
          <div className="five wide column">
            <div>
              <Field
                label="Código país"
                name="Telefono.CodigoPais"
                component={renderSelect}
                type="select"
                options={codigoPais}
              />
            </div>
          </div>
          <div className="five wide column">
            <div>
              <Field
                label="Teléfono"
                name="Telefono.NumTelefono"
                component={renderInput}
                type="number"
                required
              />
            </div>
          </div>
        </div>

      </div>
    </>
  );
};

export default Profile;